import { Avatar, Box, Skeleton, Typography } from "@mui/material";
import { sideNavStyles } from "./SideNav.styles";

const SideNavSkeleton = () => {
  return (
    <Box
      component="aside"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        width: "100%",
      }}
    >
      <Avatar sx={sideNavStyles.avatar}>
        <Skeleton variant="circular" animation="wave" />
      </Avatar>

      <Typography sx={sideNavStyles.fullName}>
        <Skeleton variant="text" width="60%" animation="wave" sx={{ margin: "0 auto" }} />
      </Typography>

      <Typography sx={sideNavStyles.about}>
        <Skeleton variant="text" width="100%" animation="wave" />
        <Skeleton variant="text" width="100%" animation="wave" />
        <Skeleton variant="text" width="75%" animation="wave" sx={{ margin: "0 auto" }} />
      </Typography>
    </Box>
  );
};

export default SideNavSkeleton;
